 <template>
  <b-row>
    <b-col>
      <!-- TODO: instead of refreshing all requests, refresh only the one clicked! -->

      <div class="dash-element-pre-loader" v-if="preLoadingRequests"></div>
      <b-row lg="12" v-else-if="noRequests" class="subtle-hints"><b-container>Booking requests from Tenants will appear here.</b-container></b-row>
      <b-row lg="12" v-for="(data, index) in dashRequests" :key="data.id+index" class="dash-element-container play-shadow" :class="{ 'opaque': data.listingStatus!='active' }">
        <b-row v-if="data.loading">
          <content-loader style="height:200; width:300">
            <rect x="200" y="15" rx="3" ry="3" width="185" height="20" />
            <rect x="200" y="70" rx="3" ry="3" width="113" height="15" />
            <rect x="200" y="105" rx="0" ry="0" width="90" height="40" />
            <rect x="12" y="15" rx="0" ry="0" width="180" height="120" />
            <rect x="310" y="105" rx="0" ry="0" width="90" height="40" />
          </content-loader>
        </b-row>
        <b-container v-else-if="!loadingPricingRules" :id="data.id" class="animated-backgroundcolor">
          <listing-request
            :request="data"
            @emitSaveRequestEdits="saveRequest"
            :pricingRules="pricingRules"
            :displayForProspect="displayForProspect"
            :loadingRedirectToggle="loadingRedirectToggle"
            @emitRedirectTo="redirectTo"
            @emitStartBookingApplication="startBookingApplication"
          ></listing-request>
        </b-container>
      </b-row>
      <div class="md-layout">
        <div class="md-layout-item md-size-10">
          <moow-button
            :type="['link']"
            btnText="Refresh"
            :loading="loadingRequests"
            @mClick="reloadRequests"
          />
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
var lodash = require("lodash/function");
import { ContentLoader } from "vue-content-loader";
import ListingRequest from "../dashboard/listingRequest.vue";
import { getPricingRules } from "../../pricing/repository/pricingRepository.js";
import { mapState } from "vuex";
// TODO: globalize this!
import { Promise } from "bluebird";
Promise.config({
  // Enable warnings
  warnings: true,
  // Enable long stack traces
  longStackTraces: true,
  // Enable cancellation
  cancellation: true,
  // Enable monitoring
  monitoring: true
});
import {
  getRequestIds,
  getRequest,
  upsertRequest,
} from "../../requestRepository.js";
import { getCurrentFirebaseUser } from "@/platform/auth/services/authService.js";

export default {
  props: {
    loadingRedirectToggle: {
      type: Function,
      required: false
    },
    saveRequest: {
      type: Function,
      required: true
    },
    prospectAndOwnerUid: {
      type: Array,
      required: false
    },
    status: {
      type: String,
      required: true
    },
    displayForProspect: {
      type: Boolean,
      required: true
    }
  },
  components: {
    "content-loader": ContentLoader,
    "listing-request": ListingRequest
  },
  data() {
    return {
      loadingPricingRules: true,
      loadingRequests: true,
      preLoadingRequests: false,
      showBookingRequestDialog: false,
      bookingRequestPeriodStart: undefined,
      bookingRequestPeriodEnd: undefined,
      disabledBookingDates: [],
      loadingDisabledBookingDates: true,
      currentlyInProcessRequestId: -1,
      editRequest: false,
      pricingRules: {}
    };
  },
  watch: {
    prospectAndOwnerUid: function(val, oldVal) {
      if(val && (val[0] != oldVal[0] || val[1] != oldVal[1])) this.reloadRequests();
    }
  },
  computed: {
    disableBookingRequest() {
      if (!this.bookingRequestPeriodEnd || !this.bookingRequestPeriodStart)
        return true;
      else return false;
    },
    // ...mapState([dashRequxests]),
    noRequests() {
      if (
        !this.$store.getters.listingRequests ||
        this.$store.getters.listingRequests.length <= 0
      ) {
        return true;
      } else return false;
    },
    dashRequests() {
      return this.orderRequests(this.$store.getters.listingRequests)
    }
  },
  created() {
    this.loadingPricingRules = true;
    if (this.prospectAndOwnerUid.length == 2 && this.status) {
      this.reloadRequests();
      getPricingRules()
        .then(result => {
          this.pricingRules = result;
          this.loadingPricingRules = false;
        })
        .catch(error => {
          console.log("listingRequests | error:", error);
        });
    }
  },
  methods: {
    redirectTo(payload){
      this.$emit("emitRedirectTo", payload)
    },
    startBookingApplication(payload){
      this.$emit("emitStartBookingApplication", payload)
    },
    // Used to update the request information by any party during negotiations
    updateRequestData(updateRequest) {
      this.replaceRequestInStore(updateRequest);
      this.flashRequestBackground(updateRequest.id)
    },
    flashRequestBackground(requestId){
      this.toggleRequestColor(requestId, "red")
      this.toggleRequestColor(requestId, "#FFFFFF")
      
    },
    toggleRequestColor: lodash.throttle(function(requestId, color) {
      document.getElementById(requestId)?document.getElementById(requestId).style.borderColor = color:void 0;
    }, 500),
    // TODO: Instead of reloading for each room save to store with room id and update only on first visit per session or with refresh
    reloadRequests() {
      this.loadingRequests = true;
      if (this.$store.getters.requestPromise) {
        try {
          this.$store.getters.requestPromise.cancel();
        } catch (err) {}
      }
      const reqPromise = this.fillRequestsInStoreFromServer(
        this.prospectAndOwnerUid[0],
        this.prospectAndOwnerUid[1],
        this.status
      );
      this.setRequestPromiseToStore(reqPromise);
      reqPromise
        .then(res => {
          this.loadingRequests = false;
        })
        .catch(err => {
          console.log(err);
          this.loadingRequests = false;
        });
    },
    fillRequestsInStoreFromServer(prospectUid, ownerUid, status) {
      
      this.resetRequestState();
      return new Promise((resolve, reject, onCancel) => {
        this.preLoadingRequests = true;
        var user = getCurrentFirebaseUser()
        this.requests = [];
        if (user && !user.isAnonymous) {
          var useruid = user.uid;

          getRequestIds(prospectUid, ownerUid, status)
            .then(response => {
              if (!response) this.notifyError("Something is not right","cannot get requests");
              else {
                this.setRequestIdsToStore(response.requestIds);
                for (var i = 0; i < response.nrOfRequests; i++) {
                  (function(source, i, response) {
                    var requestId = response.requestIds[i]._id;
                    source.addRequestToStore({ loading: true, id: requestId });
                    getRequest(requestId)
                      .then(res => {
                        if (res) source.replaceRequestInStore(res);
                        return res;
                      })
                      .catch(err => {
                        source.removeRequest(requestId);
                      })
                  })(this, i, response);
                }
                resolve();
              }
              this.preLoadingRequests = false;
            })
            .catch(err => {
              this.preLoadingRequests = false;
            });
        }
        onCancel(() => console.log("cancelled"));
      });
    },
    removeRequest(requestId) {
      this.$store.commit("REMOVE_REQUEST", requestId);
    },
    setRequestIdsToStore(requestIds) {
      this.$store.commit("SET_REQUEST_IDS", requestIds);
    },
    setRequestsToStore(requests) {
      this.$store.commit("SET_REQUEST", requests);
    },
    replaceRequestInStore(request) {
      this.$store.commit("REPLACE_REQUEST", request);
    },
    addRequestToStore(request) {
      this.$store.commit("ADD_NEW_REQUEST", request);
    },
    setRequestPromiseToStore(reqPromise) {
      this.$store.commit("SET_LATEST_REQUEST_PROMISE", reqPromise);
    },
    resetRequestState() {
      try {
        this.$store.commit("RESET_REQUESTS_STATE");
      } catch (err) {}
    },
    setPricingRulesInStore(rules) {
      try {
        this.$store.commit("SET_PRICING_RULES", rules);
      } catch (err) {}
    },
    orderRequests(requests) {
      if (requests) {
        function compare(a, b) {

          let comparison = 0;
          if (a.createdAt < b.createdAt || a.listingStatus != "active") {
            comparison = 1;
          } else if (a.createdAt > b.createdAt) {
            comparison = -1;
          }
          return comparison;
        }
        return requests.sort(compare);
      }
    },
    dismissRequest(request) {
      this.removeRequest(request.id);
      request.status = "dismissed";
      upsertRequest(request).catch(err => {this.notifyError("Request update failed")})
    },
    isPresentInArray(ar, findMe) {
      if (!ar) return false;
      var len = ar.length;
      var i = 0;
      for (; i < len; ) {
        if (ar[i] == findMe) return true;
      }
      return false;
    },
    notifyError(title, msg) {
      this.$notify({
        title: title,
        message: msg
      });
    }
  }
};
</script>
<style scoped>
@import "../../assets/styles/dashboard.css";
@import "../../assets/styles/global.css";

.request-period-view-only {
  font-size: 20px;
  text-align: center;
  line-height: 48px;
  padding-left: 15px;
}


.booking-request-content-container {
  padding: 1em;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/listingRequests.vue